module.exports = __webpack_public_path__ + "img/small_whale07.7bc6d972.jpg";